var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sm-form-stepper",class:_vm.classes?.wrapper},_vm._l((_vm.stepsArray),function(num){return _c('span',{key:num,staticClass:"step",class:[{ active: _vm.activeStep >= num }, _vm.classes?.step],on:{"click":function($event){return _vm.$emit('go-step', num)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }